import React, { ChangeEvent } from "react";
import Checkbox from "@mui/material/Checkbox";
import uncheckedIcon from "../../../assets/images/unchecked-checkbox.svg";
import checkedIcon from "../../../assets/images/checked-checkbox.svg";
import indeterminateIcon from "../../../assets/images/indeterminate.svg";
import styles from "./index.module.scss";

interface CheckboxWithTextProps {
  text: string;
  checked: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  diffStyles?: boolean;
  colorDot?: string;
  disable?: boolean;
}
const CustomCheckbox: React.FC<CheckboxWithTextProps> = ({
  text,
  checked,
  onChange,
  diffStyles,
  colorDot,
  disable,
}) => {
  console.log("diabled:", disable);
  return (
    <div
      className={
        diffStyles ? styles.checkBoxWithoutWidth : styles.checkboxContainer
      }
      style={disable ? { cursor: "not-allowed" } : undefined}
    >
      <Checkbox
        icon={
          <img
            src={uncheckedIcon}
            alt="unchecked"
            loading="lazy"
            style={
              disable ? { backgroundColor: "rgb(215, 215, 215)", borderRadius: "4px" } : {}
            }
          />
        }
        checkedIcon={
          <img
            src={checkedIcon}
            alt="checked"
            loading="lazy"
            style={
              disable ? { backgroundColor: "rgb(215, 215, 215)", borderRadius: "4px" } : {}
            }
          />
        }
        indeterminateIcon={
          <img
            src={indeterminateIcon}
            alt="indeterminate"
            style={
              disable ? { backgroundColor: "rgb(215, 215, 215)", borderRadius: "4px" } : {}
            }
          />
        }
        checked={checked}
        onChange={onChange}
        sx={{
          padding: "0px !important",
          cursor: disable ? "not-allowed" : "pointer",
          ...(disable && {
            backgroundColor: "rgb(215, 215, 215)",
            borderRadius: "4px",
            "& .MuiSvgIcon-root": {
              backgroundColor: "rgb(215, 215, 215)",
              borderRadius: "4px",
            },
          }),
        }}
      />

      {colorDot && checked && (
        <span
          className={styles.colorDot}
          style={{ backgroundColor: colorDot }}
        ></span>
      )}
      <p
        className={styles.checkboxText}
        onClick={onChange}
        style={disable ? { cursor: "not-allowed", color: "rgb(215, 215, 215)" } : undefined}
      >
        {text}
      </p>
    </div>
  );
};

export default CustomCheckbox;
